import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {GameEventComponent} from "./components/+gameevent/gameevent.component";
import {MeetingEventComponent} from "./components/+gameevent/meeting.event.component";
import {OfficeComponent} from "./components/office-screens/office.component";
//import {InstagramComponent} from "./components/+integrationCode/instagram.component";
//import {CalendarComponent} from "./components/+integrationCode/calendar.component";
//import {UserAwardComponent} from "./components/+userawardcomponent/useraward.component";
import {NPCPageComponent} from "./components/Modals/npc-modal-component";
import {MediaPageComponent} from "./components/Modals/media-modal-component";
import {ShopPageComponent} from "./components/Modals/shop-modal-component";
import {CheckVideoComponent} from "./components/+easylogin/checkvideo/checkvideo-component";
//import { SpeakerRoomComponent} from "./components/+gameevent/speaker.room.component"
//import { EventDashboardComponent} from "./components/+gameevent/event.dashboard.component"
import { MapEventComponent} from "./components/+gameevent/map.event.component"
import { CompanyLoginComponent} from "./components/+easylogin/company-login/company-login"
import { CompanyRegisterComponent} from "./components/+easylogin/company-login/company-register"
import { LivetourComponent} from "./components/livetour/livetour"

import { AvatarPageComponent } from './components/+easylogin/avatar/avatar-page-component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { TreinamentoComponent } from './components/treinamento/treinamento.component';
import { PainelAlunoComponent } from './components/painel-aluno/painel-aluno.component';
import { MeusCursosComponent } from './components/Meus-Cursos/meus-cursos.component';
import { PainelFinanceiroComponent } from './components/painel-financeiro/painel-financeiro.component';
import { DuvidasComponent } from './components/duvidas/duvidas.component';
import { DepoimentosComponent } from './components/depoimentos/depoimentos.component';
import { MeusCertificadosComponent } from './components/Meus-Certificados/meus-certificados.component';
import { SocialComponent } from './components/social/social';

const appRoutes: Routes = [
  { path: 'game',  component    :GameEventComponent },
  { path: 'avatar',  component    :AvatarPageComponent },
  { path: '',  component    :LivetourComponent },
  { path: 'gameevent/:id/',  component    : GameEventComponent },
  { path: 'meeting/:id',  component    :MeetingEventComponent },
  { path: 'map',  component    :MapEventComponent },
  { path: 'npc', component : NPCPageComponent },
  { path: 'media', component : MediaPageComponent },
  { path: 'social', component : SocialComponent },
  { path: 'shop', component : ShopPageComponent },
  { path: 'welcome', component : CheckVideoComponent },
/*  { path: 'eventdashboard/:id', component : EventDashboardComponent },
  { path: 'speakerroom/:id', component : SpeakerRoomComponent },*/
  { path: 'login/:id', component : CompanyLoginComponent },
  { path: 'login/:id', component : CompanyLoginComponent },
  { path: 'register/:id', component : CompanyRegisterComponent },
  { path: 'landing', component: LandingPageComponent},
  { path: 'treinamento', component: TreinamentoComponent },
  { path: 'treinamento/painel-aluno', component: PainelAlunoComponent }, // Painel do aluno
  { path: 'treinamento/meus-cursos', component: MeusCursosComponent },
  { path: 'treinamento/duvidas', component: DuvidasComponent },
  { path: 'treinamento/depoimentos', component: DepoimentosComponent },
  { path: 'treinamento/meus-certificados', component: MeusCertificadosComponent },
/*  { path: '', redirectTo: 'treinamento', pathMatch: 'full' }, // Redirecionamento inicial
  { path: '**', redirectTo: 'treinamento' }, // Página de fallback*/



];

    @NgModule({
      imports: [
        RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/app-routing.module.ts